/* Your personal advice in de menulade (snippets/menu-profil.liquid, opbouw van 27-10-2026).
   - Lengte, gewicht en schoenmaat gaan in hetzelfde profiel als de maatcoach (assets/maatcoach.js, localStorage maatcoach-v1:
     h, w, shoe met shoeSys); wat de maatcoach verder bewaarde (b postuur, eigen maten) blijft staan.
   - Voornaam, leeftijd en de keuze om het profiel mee te sturen staan onder een eigen sleutel (verellia-profil), zodat een
     profiel zonder maten de maatcoach niet laat denken dat er maten zijn.
   - Met een voornaam begroet de lade hem ("Hello, James").
   - Vinkt hij "Add my profile to my order" aan (standaard uit; eigenaar 27-10-2026: "ja doe het vinkje erbij"), dan staat
     zijn profiel als notitie op zijn winkelwagen (cart attribute "Profile"), en dus bij de bestelling in Shopify, zodat het team de
     maat kan controleren. Bij elke pagina kijkt het script of de notitie nog klopt (een nieuwe winkelwagen na een bestelling
     heeft hem niet); vinkt hij het uit, dan gaat de notitie eraf. Zonder vinkje gaat er niets naar een server.
   De kleuren van een eerdere versie (couleurs) worden niet meer gebruikt (eigenaar: "kleuren hoeft niet in menu").
   Sinds 28-10-2026 in de taal van de pagina (de woorden komen uit snippets/menu-profil.liquid) en in de VS en Canada in ft en in,
   lb en de Amerikaanse schoenmaat, in het Verenigd Koninkrijk in ft en in, st en lb en de EU-schoenmaat (zoals de maatcoach);
   de notitie voor het team is Engels, in cm en kg.
   Herenmaten (Verellia): lengte 140 tot 210 cm, gewicht 35 tot 180 kg, schoenmaat EU 36 tot 48 of US 4 tot 14 (de
   Amerikaanse herenmaat, zoals assets/maatcoach.js met het mannenlichaam). */
(function () {
  'use strict';
  var KEY = 'maatcoach-v1', EIGEN = 'verellia-profil', ATTR = 'Profile';

  function lees() { try { var p = JSON.parse(window.localStorage.getItem(KEY) || 'null'); return p && typeof p === 'object' ? p : {}; } catch (e) { return {}; } }
  function schrijf(p) { try { window.localStorage.setItem(KEY, JSON.stringify(p)); } catch (e) { /* privévenster: het advies werkt dan alleen op deze pagina */ } }
  function leesEigen() { try { var e = JSON.parse(window.localStorage.getItem(EIGEN) || 'null'); return e && typeof e === 'object' ? e : {}; } catch (x) { return {}; } }
  function schrijfEigen(e) { try { if (e.naam || e.age || e.delen) window.localStorage.setItem(EIGEN, JSON.stringify(e)); else window.localStorage.removeItem(EIGEN); } catch (x) { /* idem */ } }
  function getal(v) { var n = parseFloat(String(v).replace(',', '.')); return isNaN(n) ? null : n; }

  /* De notitie voor de bestelling, in het Engels zoals het team hem in Shopify leest. */
  function notitie(p, eigen) {
    var d = [];
    if (eigen.naam) d.push(eigen.naam);
    if (eigen.age) d.push(eigen.age + ' yrs');
    if (p.h) d.push(p.h + ' cm');
    if (p.w) d.push(p.w + ' kg');
    if (p.shoe) d.push('shoe size ' + String(p.shoe) + (p.shoeSys === 'us' ? ' US' : ' EU'));
    return d.join(' · ');
  }
  /* Zet de notitie op de winkelwagen als die anders is; leeg haalt hem weg. */
  function zetNotitie(tekst) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var nu = (cart.attributes && cart.attributes[ATTR]) || '';
        if (nu === tekst) return;
        var body = { attributes: {} };
        body.attributes[ATTR] = tekst;
        return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      })
      .catch(function () { /* geen verbinding: bij de volgende pagina opnieuw */ });
  }
  (function bijLaden() {
    var eigen = leesEigen();
    if (!eigen.delen) return;
    var t = notitie(lees(), eigen);
    if (t) zetNotitie(t);
  })();

  var box = document.querySelector('[data-profil]');
  if (!box) return;
  var panel = box.closest('.menu__panel');
  var form = box.querySelector('[data-profil-form]');
  var tekst = box.querySelector('[data-profil-tekst]');
  var actie = box.querySelector('[data-profil-actie]');
  var fout = box.querySelector('[data-profil-fout]');
  var leeg = tekst.textContent;
  /* De woorden in de taal van de pagina (snippets/menu-profil.liquid, store.menu_profil; 28-10-2026 ook Engels), en in de markten
     met voeten en ponden (data-profil-imperial: de VS en Canada) ft en in, lb en de Amerikaanse schoenmaat. Bewaard wordt in cm
     en kg, zoals de maatcoach. */
  function woord(k, terug) { return box.getAttribute('data-text-' + k) || terug; }
  var imperial = box.hasAttribute('data-profil-imperial');
  /* Verenigd Koninkrijk (data-profil-stone, 28-10-2026): het gewicht in st en lb, de schoenmaat in EU. */
  var stone = box.hasAttribute('data-profil-stone');
  var usSchoen = imperial && !stone;
  /* Voeten en ponden alleen voor een bezoeker uit een land dat zo meet (eigenaar 28-10-2026: "een duitse en nederlandse klant
     (EU) [zagen] inches maten ... afhankelijk waar klant vandaan komt"): wie uit een ander land komt, ook op /en-gb of /en-us,
     krijgt cm, kg en de EU-schoenmaat. Het land is dat van Shopify (sessionStorage 'detected-country', zoals
     snippets/country-redirect.liquid); onbekend: de markt. Dezelfde regel als de maatcoach (assets/maatcoach.js, unitsFor);
     samen wijzigen. De metrische velden staan klaar in <template data-profil-metric> (snippets/menu-profil.liquid). */
  function landBezoeker() { try { return String(window.sessionStorage.getItem('detected-country') || '').toUpperCase(); } catch (e) { return ''; } }
  function naarMetrisch() {
    var land = landBezoeker();
    var klaar = form.querySelectorAll('template[data-profil-metric]');
    if (!imperial || !klaar.length || !land || /^(US|CA|LR|MM|GB)$/.test(land)) return false;
    [].forEach.call(klaar, function (t) {
      if (t.previousElementSibling) t.previousElementSibling.replaceWith(t.content.cloneNode(true));
      t.remove();
    });
    fout.textContent = woord('error-metric', fout.textContent);
    imperial = false;
    stone = false;
    usSchoen = false;
    return true;
  }
  function voet(cm) { var i = Math.round(cm / 2.54); return Math.floor(i / 12) + '′' + (i % 12) + '″'; }
  function pond(kg) { return Math.round(kg / 0.45359237); }
  function gewicht(kg) { var lb = pond(kg); return stone ? Math.floor(lb / 14) + ' st ' + (lb % 14) + ' lb' : lb + ' lb'; }
  function schoen(p) {
    var us = p.shoeSys === 'us';
    var maat = us ? String(p.shoe) : String(p.shoe).replace('.', ',');
    return woord(us ? 'shoe-us' : 'shoe-eu', us ? 'US %size%' : 'shoe size %size%').replace('%size%', maat);
  }
  var hallo = null;
  if (panel) {
    hallo = document.createElement('p');
    hallo.className = 'menu-hello';
    hallo.hidden = true;
    var kop = panel.querySelector('.menu__head');
    if (kop) kop.insertAdjacentElement('afterend', hallo);
  }

  function toon(p, bedankt) {
    var eigen = leesEigen();
    var delen = [];
    if (p.h) delen.push(imperial ? voet(p.h) : p.h + ' cm');
    if (p.w) delen.push(imperial ? gewicht(p.w) : Math.round(p.w) + ' kg');
    if (p.shoe) delen.push(schoen(p));
    if (hallo) { hallo.textContent = eigen.naam ? woord('hello', 'Hello, %name%').replace('%name%', eigen.naam) : ''; hallo.hidden = !eigen.naam; }
    if (!delen.length && !eigen.naam) { tekst.textContent = leeg; actie.textContent = woord('add', 'Fill in'); box.classList.remove('is-ingevuld'); return; }
    var merci = woord('thanks', 'Thank you');
    var groet = eigen.naam ? (bedankt ? merci + ', ' : '') + eigen.naam : (bedankt ? merci : '');
    tekst.textContent = [groet].concat(delen).filter(Boolean).join(' · ');
    actie.textContent = woord('edit', 'Edit');
    box.classList.add('is-ingevuld');
  }

  function vul(p) {
    var eigen = leesEigen();
    form.elements.naam.value = eigen.naam || '';
    form.elements.age.value = eigen.age || '';
    if (imperial) {
      var duim = p.h ? Math.round(p.h / 2.54) : null;
      form.elements.hft.value = duim ? Math.floor(duim / 12) : '';
      form.elements.hin.value = duim ? duim % 12 : '';
      var lb = p.w ? pond(p.w) : null;
      if (stone) {
        form.elements.wst.value = lb ? Math.floor(lb / 14) : '';
        form.elements.wlb.value = lb ? lb % 14 : '';
      } else form.elements.wlb.value = lb || '';
      form.elements.shoe.value = p.shoe && (p.shoeSys === 'us') === usSchoen ? p.shoe : '';
    } else {
      form.elements.h.value = p.h || '';
      form.elements.w.value = p.w ? Math.round(p.w) : '';
      form.elements.shoe.value = p.shoe && p.shoeSys !== 'us' ? p.shoe : '';
    }
    form.elements.delen.checked = !!eigen.delen;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var h, w, s = getal(form.elements.shoe.value), a = getal(form.elements.age.value);
    if (imperial) {
      var ft = getal(form.elements.hft.value), inch = getal(form.elements.hin.value);
      var lb = getal(form.elements.wlb.value);
      if (stone) { var sto = getal(form.elements.wst.value); lb = sto == null && lb == null ? null : (sto || 0) * 14 + (lb || 0); }
      h = ft == null && inch == null ? null : ((ft || 0) * 12 + (inch || 0)) * 2.54;
      w = lb == null ? null : lb * 0.45359237;
    } else {
      h = getal(form.elements.h.value);
      w = getal(form.elements.w.value);
    }
    /* Dezelfde grenzen in beide stelsels, voor heren: 140 tot 210 cm, 35 tot 180 kg; de schoenmaat EU 36 tot 48 of US 4 tot 14. */
    var ok = (h == null || (h >= 139.5 && h <= 210.7)) && (w == null || (w >= 34.9 && w <= 180.2)) && (s == null || (usSchoen ? s >= 4 && s <= 14 : s >= 36 && s <= 48)) && (a == null || (a >= 16 && a <= 99));
    fout.hidden = ok;
    if (!ok) return;
    var p = lees();
    var eigen = { naam: form.elements.naam.value.trim().slice(0, 30) || undefined, age: a != null ? Math.round(a) : undefined, delen: form.elements.delen.checked || undefined };
    schrijfEigen(eigen);
    if (h != null) p.h = Math.round(h); else delete p.h;
    if (w != null) p.w = imperial ? Math.round(w * 10) / 10 : Math.round(w); else delete p.w;
    var stelsel = usSchoen ? 'us' : 'eu';
    if (s != null) { p.shoe = Math.round(s * 2) / 2; p.shoeSys = stelsel; } else if (p.shoeSys === stelsel || !p.shoeSys) { delete p.shoe; delete p.shoeSys; }
    /* Alleen een profiel met maten schrijven; de maatcoach kiest zelf zijn standaardpostuur (b) als het ontbreekt. */
    if (p.h || p.w || p.shoe || p.waist || p.hip) { if (!p.b) p.b = 'mid'; schrijf(p); } else { try { window.localStorage.removeItem(KEY); } catch (x) { /* idem */ } }
    zetNotitie(eigen.delen ? notitie(p, eigen) : '');
    toon(p, true);
    box.open = false;
  });

  box.addEventListener('toggle', function () { if (box.open) { vul(lees()); fout.hidden = true; } });
  naarMetrisch();
  /* Land nog onbekend in een markt met voeten en ponden: één keer vragen, en zo nodig de velden en de regel omzetten. */
  if (imperial && !landBezoeker() && window.fetch) {
    window.fetch('/browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var land = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        if (!land) return;
        try { window.sessionStorage.setItem('detected-country', land); } catch (e) { /* geen opslag */ }
        if (naarMetrisch()) { toon(lees(), false); if (box.open) vul(lees()); }
      })
      .catch(function () { /* geen land: de markt beslist */ });
  }
  toon(lees(), false);
  box.hidden = false;
})();
